<app-line-item-monitor-grid
  [gridHeader]="gridHeader"
  [gridValues]="gridValues"
  [widthConfig]="widthConfig"
  [isLoading]="isLoading"
  [lineItemsMeta]="lineItemsMeta"
  (onPeriodUpdate)="onPeriodChange($event[0], $event[1], $event[2])"
  [tabName]="'Revision'"
  [ticker]="ticker"
></app-line-item-monitor-grid>

<div
  *ngIf="gridValues.length === 0 && isLoading === false"
  class="error-container"
>
  <div class="error-msg msg-position">
    <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
    <span class="error-text">Data is not available</span>
  </div>
</div>
